import { NotificationsApiFactory } from '@eloomi/eloomi-notifications-persona-client/1.0';
import { authorizeClient } from '@/api/http-client';

export const notificationsClient = authorizeClient(NotificationsApiFactory);
